import { render, staticRenderFns } from "./DDTControllate.vue?vue&type=template&id=57eef4f8&"
import script from "./DDTControllate.vue?vue&type=script&lang=js&"
export * from "./DDTControllate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports